export type CountryType = {
  label: string
  code: string
  phone: string
  language: string
  nativeLanguage: string
  suggested?: boolean
}

export function splitCurrencyPair(pair: string): [string, string] {
  if (!pair) {
    return ['', '']
  }

  const [base, quote] = pair.split('/')

  if (!base || !quote) {
    throw new Error(
      'Invalid currency pair format. Expected format: BASE/QUOTE (e.g., USD/IRR)'
    )
  }

  return [base, quote]
}

export function countryToFlag(isoCode: string = '') {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode
}

export const countries: CountryType[] = [
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '98',
    language: 'Persian',
    nativeLanguage: 'فارسی'
  },
  {
    code: 'AD',
    label: 'Andorra',
    phone: '376',
    language: 'Andorra',
    nativeLanguage: ''
  },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'AF',
    label: 'Afghanistan',
    phone: '93',
    language: 'Pashto',
    nativeLanguage: ''
  },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '1-268',
    language: 'Antigua and barbuda',
    nativeLanguage: ''
  },
  {
    code: 'AI',
    label: 'Anguilla',
    phone: '1-264',
    language: 'Anguilla',
    nativeLanguage: ''
  },
  {
    code: 'AL',
    label: 'Albania',
    phone: '355',
    language: 'Albanian',
    nativeLanguage: ''
  },
  {
    code: 'AM',
    label: 'Armenia',
    phone: '374',
    language: 'Armenian',
    nativeLanguage: ''
  },
  {
    code: 'AO',
    label: 'Angola',
    phone: '244',
    language: 'Angola',
    nativeLanguage: ''
  },
  {
    code: 'AQ',
    label: 'Antarctica',
    phone: '672',
    language: 'Antarctica',
    nativeLanguage: ''
  },
  {
    code: 'AR',
    label: 'Argentina',
    phone: '54',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'AS',
    label: 'American Samoa',
    phone: '1-684',
    language: 'American samoa',
    nativeLanguage: ''
  },
  {
    code: 'AT',
    label: 'Austria',
    phone: '43',
    language: 'German',
    nativeLanguage: ''
  },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    suggested: true,
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'AW',
    label: 'Aruba',
    phone: '297',
    language: 'Aruba',
    nativeLanguage: ''
  },
  {
    code: 'AX',
    label: 'Alland Islands',
    phone: '358',
    language: 'Alland islands',
    nativeLanguage: ''
  },
  {
    code: 'AZ',
    label: 'Azerbaijan',
    phone: '994',
    language: 'Azeri (latin)',
    nativeLanguage: ''
  },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '387',
    language: 'Serbian (latin)',
    nativeLanguage: ''
  },
  {
    code: 'BB',
    label: 'Barbados',
    phone: '1-246',
    language: 'Barbados',
    nativeLanguage: ''
  },
  {
    code: 'BD',
    label: 'Bangladesh',
    phone: '880',
    language: 'Bengali',
    nativeLanguage: ''
  },
  {
    code: 'BE',
    label: 'Belgium',
    phone: '32',
    language: 'French',
    nativeLanguage: ''
  },
  {
    code: 'BF',
    label: 'Burkina Faso',
    phone: '226',
    language: 'Burkina faso',
    nativeLanguage: ''
  },
  {
    code: 'BG',
    label: 'Bulgaria',
    phone: '359',
    language: 'Bulgarian',
    nativeLanguage: ''
  },
  {
    code: 'BH',
    label: 'Bahrain',
    phone: '973',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'BI',
    label: 'Burundi',
    phone: '257',
    language: 'Burundi',
    nativeLanguage: ''
  },
  {
    code: 'BJ',
    label: 'Benin',
    phone: '229',
    language: 'Benin',
    nativeLanguage: ''
  },
  {
    code: 'BL',
    label: 'Saint Barthelemy',
    phone: '590',
    language: 'Saint barthelemy',
    nativeLanguage: ''
  },
  {
    code: 'BM',
    label: 'Bermuda',
    phone: '1-441',
    language: 'Bermuda',
    nativeLanguage: ''
  },
  {
    code: 'BN',
    label: 'Brunei Darussalam',
    phone: '673',
    language: 'Malay',
    nativeLanguage: ''
  },
  {
    code: 'BO',
    label: 'Bolivia',
    phone: '591',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'BR',
    label: 'Brazil',
    phone: '55',
    language: 'Portuguese',
    nativeLanguage: ''
  },
  {
    code: 'BS',
    label: 'Bahamas',
    phone: '1-242',
    language: 'Bahamas',
    nativeLanguage: ''
  },
  {
    code: 'BT',
    label: 'Bhutan',
    phone: '975',
    language: 'Bhutan',
    nativeLanguage: ''
  },
  {
    code: 'BV',
    label: 'Bouvet Island',
    phone: '47',
    language: 'Bouvet island',
    nativeLanguage: ''
  },
  {
    code: 'BW',
    label: 'Botswana',
    phone: '267',
    language: 'Botswana',
    nativeLanguage: ''
  },
  {
    code: 'BY',
    label: 'Belarus',
    phone: '375',
    language: 'Belarusian',
    nativeLanguage: ''
  },
  {
    code: 'BZ',
    label: 'Belize',
    phone: '501',
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'CA',
    label: 'Canada',
    phone: '1',
    suggested: true,
    language: 'Mohawk',
    nativeLanguage: ''
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '61',
    language: 'Cocos (keeling) islands',
    nativeLanguage: ''
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
    language: 'Congo, democratic republic of the',
    nativeLanguage: ''
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
    language: 'Central african republic',
    nativeLanguage: ''
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '242',
    language: 'Congo, republic of the',
    nativeLanguage: ''
  },
  {
    code: 'CH',
    label: 'Switzerland',
    phone: '41',
    language: 'Romansh',
    nativeLanguage: ''
  },
  {
    code: 'CI',
    label: "Cote d'Ivoire",
    phone: '225',
    language: "Cote d'ivoire",
    nativeLanguage: ''
  },
  {
    code: 'CK',
    label: 'Cook Islands',
    phone: '682',
    language: 'Cook islands',
    nativeLanguage: ''
  },
  {
    code: 'CL',
    label: 'Chile',
    phone: '56',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'CM',
    label: 'Cameroon',
    phone: '237',
    language: 'Cameroon',
    nativeLanguage: ''
  },
  {
    code: 'CN',
    label: 'China',
    phone: '86',
    language: 'Yi',
    nativeLanguage: ''
  },
  {
    code: 'CO',
    label: 'Colombia',
    phone: '57',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'CR',
    label: 'Costa Rica',
    phone: '506',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'CU',
    label: 'Cuba',
    phone: '53',
    language: 'Cuba',
    nativeLanguage: ''
  },
  {
    code: 'CV',
    label: 'Cape Verde',
    phone: '238',
    language: 'Cape verde',
    nativeLanguage: ''
  },
  {
    code: 'CW',
    label: 'Curacao',
    phone: '599',
    language: 'Curacao',
    nativeLanguage: ''
  },
  {
    code: 'CX',
    label: 'Christmas Island',
    phone: '61',
    language: 'Christmas island',
    nativeLanguage: ''
  },
  {
    code: 'CY',
    label: 'Cyprus',
    phone: '357',
    language: 'Cyprus',
    nativeLanguage: ''
  },
  {
    code: 'CZ',
    label: 'Czech Republic',
    phone: '420',
    language: 'Czech',
    nativeLanguage: ''
  },
  {
    code: 'DE',
    label: 'Germany',
    phone: '49',
    suggested: true,
    language: 'Upper sorbian',
    nativeLanguage: ''
  },
  {
    code: 'DJ',
    label: 'Djibouti',
    phone: '253',
    language: 'Djibouti',
    nativeLanguage: ''
  },
  {
    code: 'DK',
    label: 'Denmark',
    phone: '45',
    language: 'Danish',
    nativeLanguage: ''
  },
  {
    code: 'DM',
    label: 'Dominica',
    phone: '1-767',
    language: 'Dominica',
    nativeLanguage: ''
  },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '1-809',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'DZ',
    label: 'Algeria',
    phone: '213',
    language: 'Tamazight (latin)',
    nativeLanguage: ''
  },
  {
    code: 'EC',
    label: 'Ecuador',
    phone: '593',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'EE',
    label: 'Estonia',
    phone: '372',
    language: 'Estonian',
    nativeLanguage: ''
  },
  {
    code: 'EG',
    label: 'Egypt',
    phone: '20',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'EH',
    label: 'Western Sahara',
    phone: '212',
    language: 'Western sahara',
    nativeLanguage: ''
  },
  {
    code: 'ER',
    label: 'Eritrea',
    phone: '291',
    language: 'Eritrea',
    nativeLanguage: ''
  },
  {
    code: 'ES',
    label: 'Spain',
    phone: '34',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'ET',
    label: 'Ethiopia',
    phone: '251',
    language: 'Amharic',
    nativeLanguage: ''
  },
  {
    code: 'FI',
    label: 'Finland',
    phone: '358',
    language: 'Swedish',
    nativeLanguage: ''
  },
  {
    code: 'FJ',
    label: 'Fiji',
    phone: '679',
    language: 'Fiji',
    nativeLanguage: ''
  },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '500',
    language: 'Falkland islands (malvinas)',
    nativeLanguage: ''
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '691',
    language: 'Micronesia, federated states of',
    nativeLanguage: ''
  },
  {
    code: 'FO',
    label: 'Faroe Islands',
    phone: '298',
    language: 'Faroese',
    nativeLanguage: ''
  },
  {
    code: 'FR',
    label: 'France',
    phone: '33',
    suggested: true,
    language: 'Occitan',
    nativeLanguage: ''
  },
  {
    code: 'GA',
    label: 'Gabon',
    phone: '241',
    language: 'Gabon',
    nativeLanguage: ''
  },
  {
    code: 'GB',
    label: 'United Kingdom',
    phone: '44',
    language: 'Welsh',
    nativeLanguage: ''
  },
  {
    code: 'GD',
    label: 'Grenada',
    phone: '1-473',
    language: 'Grenada',
    nativeLanguage: ''
  },
  {
    code: 'GE',
    label: 'Georgia',
    phone: '995',
    language: 'Georgian',
    nativeLanguage: ''
  },
  {
    code: 'GF',
    label: 'French Guiana',
    phone: '594',
    language: 'French guiana',
    nativeLanguage: ''
  },
  {
    code: 'GG',
    label: 'Guernsey',
    phone: '44',
    language: 'Guernsey',
    nativeLanguage: ''
  },
  {
    code: 'GH',
    label: 'Ghana',
    phone: '233',
    language: 'Ghana',
    nativeLanguage: ''
  },
  {
    code: 'GI',
    label: 'Gibraltar',
    phone: '350',
    language: 'Gibraltar',
    nativeLanguage: ''
  },
  {
    code: 'GL',
    label: 'Greenland',
    phone: '299',
    language: 'Greenlandic',
    nativeLanguage: ''
  },
  {
    code: 'GM',
    label: 'Gambia',
    phone: '220',
    language: 'Gambia',
    nativeLanguage: ''
  },
  {
    code: 'GN',
    label: 'Guinea',
    phone: '224',
    language: 'Guinea',
    nativeLanguage: ''
  },
  {
    code: 'GP',
    label: 'Guadeloupe',
    phone: '590',
    language: 'Guadeloupe',
    nativeLanguage: ''
  },
  {
    code: 'GQ',
    label: 'Equatorial Guinea',
    phone: '240',
    language: 'Equatorial guinea',
    nativeLanguage: ''
  },
  {
    code: 'GR',
    label: 'Greece',
    phone: '30',
    language: 'Greek',
    nativeLanguage: ''
  },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
    language: 'South georgia and the south sandwich islands',
    nativeLanguage: ''
  },
  {
    code: 'GT',
    label: 'Guatemala',
    phone: '502',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'GU',
    label: 'Guam',
    phone: '1-671',
    language: 'Guam',
    nativeLanguage: ''
  },
  {
    code: 'GW',
    label: 'Guinea-Bissau',
    phone: '245',
    language: 'Guinea-bissau',
    nativeLanguage: ''
  },
  {
    code: 'GY',
    label: 'Guyana',
    phone: '592',
    language: 'Guyana',
    nativeLanguage: ''
  },
  {
    code: 'HK',
    label: 'Hong Kong',
    phone: '852',
    language: 'Chinese (traditional) legacy',
    nativeLanguage: ''
  },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
    language: 'Heard island and mcdonald islands',
    nativeLanguage: ''
  },
  {
    code: 'HN',
    label: 'Honduras',
    phone: '504',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'HR',
    label: 'Croatia',
    phone: '385',
    language: 'Croatian',
    nativeLanguage: ''
  },
  {
    code: 'HT',
    label: 'Haiti',
    phone: '509',
    language: 'Haiti',
    nativeLanguage: ''
  },
  {
    code: 'HU',
    label: 'Hungary',
    phone: '36',
    language: 'Hungarian',
    nativeLanguage: ''
  },
  {
    code: 'ID',
    label: 'Indonesia',
    phone: '62',
    language: 'Indonesian',
    nativeLanguage: ''
  },
  {
    code: 'IE',
    label: 'Ireland',
    phone: '353',
    language: 'Irish',
    nativeLanguage: ''
  },
  {
    code: 'IL',
    label: 'Israel',
    phone: '972',
    language: 'Hebrew',
    nativeLanguage: ''
  },
  {
    code: 'IM',
    label: 'Isle of Man',
    phone: '44',
    language: 'Isle of man',
    nativeLanguage: ''
  },
  {
    code: 'IN',
    label: 'India',
    phone: '91',
    language: 'Telugu',
    nativeLanguage: ''
  },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
    language: 'British indian ocean territory',
    nativeLanguage: ''
  },
  {
    code: 'IQ',
    label: 'Iraq',
    phone: '964',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'IS',
    label: 'Iceland',
    phone: '354',
    language: 'Icelandic',
    nativeLanguage: ''
  },
  {
    code: 'IT',
    label: 'Italy',
    phone: '39',
    language: 'Italian',
    nativeLanguage: ''
  },
  {
    code: 'JE',
    label: 'Jersey',
    phone: '44',
    language: 'Jersey',
    nativeLanguage: ''
  },
  {
    code: 'JM',
    label: 'Jamaica',
    phone: '1-876',
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'JO',
    label: 'Jordan',
    phone: '962',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'JP',
    label: 'Japan',
    phone: '81',
    suggested: true,
    language: 'Japanese',
    nativeLanguage: ''
  },
  {
    code: 'KE',
    label: 'Kenya',
    phone: '254',
    language: 'Kiswahili',
    nativeLanguage: ''
  },
  {
    code: 'KG',
    label: 'Kyrgyzstan',
    phone: '996',
    language: 'Kyrgyz',
    nativeLanguage: ''
  },
  {
    code: 'KH',
    label: 'Cambodia',
    phone: '855',
    language: 'Khmer',
    nativeLanguage: ''
  },
  {
    code: 'KI',
    label: 'Kiribati',
    phone: '686',
    language: 'Kiribati',
    nativeLanguage: ''
  },
  {
    code: 'KM',
    label: 'Comoros',
    phone: '269',
    language: 'Comoros',
    nativeLanguage: ''
  },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
    language: 'Saint kitts and nevis',
    nativeLanguage: ''
  },
  {
    code: 'KP',
    label: "Korea, Democratic People's Republic of",
    phone: '850',
    language: "Korea, democratic people's republic of",
    nativeLanguage: ''
  },
  {
    code: 'KR',
    label: 'Korea, Republic of',
    phone: '82',
    language: 'Korean',
    nativeLanguage: ''
  },
  {
    code: 'KW',
    label: 'Kuwait',
    phone: '965',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'KY',
    label: 'Cayman Islands',
    phone: '1-345',
    language: 'Cayman islands',
    nativeLanguage: ''
  },
  {
    code: 'KZ',
    label: 'Kazakhstan',
    phone: '7',
    language: 'Kazakh',
    nativeLanguage: ''
  },
  {
    code: 'LA',
    label: "Lao People's Democratic Republic",
    phone: '856',
    language: 'Lao',
    nativeLanguage: ''
  },
  {
    code: 'LB',
    label: 'Lebanon',
    phone: '961',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'LC',
    label: 'Saint Lucia',
    phone: '1-758',
    language: 'Saint lucia',
    nativeLanguage: ''
  },
  {
    code: 'LI',
    label: 'Liechtenstein',
    phone: '423',
    language: 'German',
    nativeLanguage: ''
  },
  {
    code: 'LK',
    label: 'Sri Lanka',
    phone: '94',
    language: 'Sinhala',
    nativeLanguage: ''
  },
  {
    code: 'LR',
    label: 'Liberia',
    phone: '231',
    language: 'Liberia',
    nativeLanguage: ''
  },
  {
    code: 'LS',
    label: 'Lesotho',
    phone: '266',
    language: 'Lesotho',
    nativeLanguage: ''
  },
  {
    code: 'LT',
    label: 'Lithuania',
    phone: '370',
    language: 'Lithuanian',
    nativeLanguage: ''
  },
  {
    code: 'LU',
    label: 'Luxembourg',
    phone: '352',
    language: 'Luxembourgish',
    nativeLanguage: ''
  },
  {
    code: 'LV',
    label: 'Latvia',
    phone: '371',
    language: 'Latvian',
    nativeLanguage: ''
  },
  {
    code: 'LY',
    label: 'Libya',
    phone: '218',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'MA',
    label: 'Morocco',
    phone: '212',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'MC',
    label: 'Monaco',
    phone: '377',
    language: 'French',
    nativeLanguage: ''
  },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '373',
    language: 'Moldova, republic of',
    nativeLanguage: ''
  },
  {
    code: 'ME',
    label: 'Montenegro',
    phone: '382',
    language: 'Serbian (latin)',
    nativeLanguage: ''
  },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '590',
    language: 'Saint martin (french part)',
    nativeLanguage: ''
  },
  {
    code: 'MG',
    label: 'Madagascar',
    phone: '261',
    language: 'Madagascar',
    nativeLanguage: ''
  },
  {
    code: 'MH',
    label: 'Marshall Islands',
    phone: '692',
    language: 'Marshall islands',
    nativeLanguage: ''
  },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
    language: 'Macedonian (fyrom)',
    nativeLanguage: ''
  },
  {
    code: 'ML',
    label: 'Mali',
    phone: '223',
    language: 'Mali',
    nativeLanguage: ''
  },
  {
    code: 'MM',
    label: 'Myanmar',
    phone: '95',
    language: 'Myanmar',
    nativeLanguage: ''
  },
  {
    code: 'MN',
    label: 'Mongolia',
    phone: '976',
    language: 'Mongolian (cyrillic)',
    nativeLanguage: ''
  },
  {
    code: 'MO',
    label: 'Macao',
    phone: '853',
    language: 'Chinese (traditional) legacy',
    nativeLanguage: ''
  },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
    language: 'Northern mariana islands',
    nativeLanguage: ''
  },
  {
    code: 'MQ',
    label: 'Martinique',
    phone: '596',
    language: 'Martinique',
    nativeLanguage: ''
  },
  {
    code: 'MR',
    label: 'Mauritania',
    phone: '222',
    language: 'Mauritania',
    nativeLanguage: ''
  },
  {
    code: 'MS',
    label: 'Montserrat',
    phone: '1-664',
    language: 'Montserrat',
    nativeLanguage: ''
  },
  {
    code: 'MT',
    label: 'Malta',
    phone: '356',
    language: 'Maltese',
    nativeLanguage: ''
  },
  {
    code: 'MU',
    label: 'Mauritius',
    phone: '230',
    language: 'Mauritius',
    nativeLanguage: ''
  },
  {
    code: 'MV',
    label: 'Maldives',
    phone: '960',
    language: 'Divehi',
    nativeLanguage: ''
  },
  {
    code: 'MW',
    label: 'Malawi',
    phone: '265',
    language: 'Malawi',
    nativeLanguage: ''
  },
  {
    code: 'MX',
    label: 'Mexico',
    phone: '52',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'MY',
    label: 'Malaysia',
    phone: '60',
    language: 'Malay',
    nativeLanguage: ''
  },
  {
    code: 'MZ',
    label: 'Mozambique',
    phone: '258',
    language: 'Mozambique',
    nativeLanguage: ''
  },
  {
    code: 'NA',
    label: 'Namibia',
    phone: '264',
    language: 'Namibia',
    nativeLanguage: ''
  },
  {
    code: 'NC',
    label: 'New Caledonia',
    phone: '687',
    language: 'New caledonia',
    nativeLanguage: ''
  },
  {
    code: 'NE',
    label: 'Niger',
    phone: '227',
    language: 'Niger',
    nativeLanguage: ''
  },
  {
    code: 'NF',
    label: 'Norfolk Island',
    phone: '672',
    language: 'Norfolk island',
    nativeLanguage: ''
  },
  {
    code: 'NG',
    label: 'Nigeria',
    phone: '234',
    language: 'Yoruba',
    nativeLanguage: ''
  },
  {
    code: 'NI',
    label: 'Nicaragua',
    phone: '505',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'NL',
    label: 'Netherlands',
    phone: '31',
    language: 'Frisian',
    nativeLanguage: ''
  },
  {
    code: 'NO',
    label: 'Norway',
    phone: '47',
    language: 'Sami (southern)',
    nativeLanguage: ''
  },
  {
    code: 'NP',
    label: 'Nepal',
    phone: '977',
    language: 'Nepali',
    nativeLanguage: ''
  },
  {
    code: 'NR',
    label: 'Nauru',
    phone: '674',
    language: 'Nauru',
    nativeLanguage: ''
  },
  {
    code: 'NU',
    label: 'Niue',
    phone: '683',
    language: 'Niue',
    nativeLanguage: ''
  },
  {
    code: 'NZ',
    label: 'New Zealand',
    phone: '64',
    language: 'Maori',
    nativeLanguage: ''
  },
  {
    code: 'OM',
    label: 'Oman',
    phone: '968',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'PA',
    label: 'Panama',
    phone: '507',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'PE',
    label: 'Peru',
    phone: '51',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'PF',
    label: 'French Polynesia',
    phone: '689',
    language: 'French polynesia',
    nativeLanguage: ''
  },
  {
    code: 'PG',
    label: 'Papua New Guinea',
    phone: '675',
    language: 'Papua new guinea',
    nativeLanguage: ''
  },
  {
    code: 'PH',
    label: 'Philippines',
    phone: '63',
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'PK',
    label: 'Pakistan',
    phone: '92',
    language: 'Urdu',
    nativeLanguage: ''
  },
  {
    code: 'PL',
    label: 'Poland',
    phone: '48',
    language: 'Polish',
    nativeLanguage: ''
  },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
    language: 'Saint pierre and miquelon',
    nativeLanguage: ''
  },
  {
    code: 'PN',
    label: 'Pitcairn',
    phone: '870',
    language: 'Pitcairn',
    nativeLanguage: ''
  },
  {
    code: 'PR',
    label: 'Puerto Rico',
    phone: '1',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '970',
    language: 'Palestine, state of',
    nativeLanguage: ''
  },
  {
    code: 'PT',
    label: 'Portugal',
    phone: '351',
    language: 'Portuguese',
    nativeLanguage: ''
  },
  {
    code: 'PW',
    label: 'Palau',
    phone: '680',
    language: 'Palau',
    nativeLanguage: ''
  },
  {
    code: 'PY',
    label: 'Paraguay',
    phone: '595',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'QA',
    label: 'Qatar',
    phone: '974',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'RE',
    label: 'Reunion',
    phone: '262',
    language: 'Reunion',
    nativeLanguage: ''
  },
  {
    code: 'RO',
    label: 'Romania',
    phone: '40',
    language: 'Romanian',
    nativeLanguage: ''
  },
  {
    code: 'RS',
    label: 'Serbia',
    phone: '381',
    language: 'Serbian (latin)',
    nativeLanguage: ''
  },
  {
    code: 'RU',
    label: 'Russian Federation',
    phone: '7',
    language: 'Yakut',
    nativeLanguage: ''
  },
  {
    code: 'RW',
    label: 'Rwanda',
    phone: '250',
    language: 'Kinyarwanda',
    nativeLanguage: ''
  },
  {
    code: 'SA',
    label: 'Saudi Arabia',
    phone: '966',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'SB',
    label: 'Solomon Islands',
    phone: '677',
    language: 'Solomon islands',
    nativeLanguage: ''
  },
  {
    code: 'SC',
    label: 'Seychelles',
    phone: '248',
    language: 'Seychelles',
    nativeLanguage: ''
  },
  {
    code: 'SD',
    label: 'Sudan',
    phone: '249',
    language: 'Sudan',
    nativeLanguage: ''
  },
  {
    code: 'SE',
    label: 'Sweden',
    phone: '46',
    language: 'Swedish',
    nativeLanguage: ''
  },
  {
    code: 'SG',
    label: 'Singapore',
    phone: '65',
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'SH',
    label: 'Saint Helena',
    phone: '290',
    language: 'Saint helena',
    nativeLanguage: ''
  },
  {
    code: 'SI',
    label: 'Slovenia',
    phone: '386',
    language: 'Slovenian',
    nativeLanguage: ''
  },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '47',
    language: 'Svalbard and jan mayen',
    nativeLanguage: ''
  },
  {
    code: 'SK',
    label: 'Slovakia',
    phone: '421',
    language: 'Slovak',
    nativeLanguage: ''
  },
  {
    code: 'SL',
    label: 'Sierra Leone',
    phone: '232',
    language: 'Sierra leone',
    nativeLanguage: ''
  },
  {
    code: 'SM',
    label: 'San Marino',
    phone: '378',
    language: 'San marino',
    nativeLanguage: ''
  },
  {
    code: 'SN',
    label: 'Senegal',
    phone: '221',
    language: 'Wolof',
    nativeLanguage: ''
  },
  {
    code: 'SO',
    label: 'Somalia',
    phone: '252',
    language: 'Somalia',
    nativeLanguage: ''
  },
  {
    code: 'SR',
    label: 'Suriname',
    phone: '597',
    language: 'Suriname',
    nativeLanguage: ''
  },
  {
    code: 'SS',
    label: 'South Sudan',
    phone: '211',
    language: 'South sudan',
    nativeLanguage: ''
  },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '239',
    language: 'Sao tome and principe',
    nativeLanguage: ''
  },
  {
    code: 'SV',
    label: 'El Salvador',
    phone: '503',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '1-721',
    language: 'Sint maarten (dutch part)',
    nativeLanguage: ''
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '963',
    language: 'Syriac',
    nativeLanguage: ''
  },
  {
    code: 'SZ',
    label: 'Swaziland',
    phone: '268',
    language: 'Swaziland',
    nativeLanguage: ''
  },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
    language: 'Turks and caicos islands',
    nativeLanguage: ''
  },
  {
    code: 'TD',
    label: 'Chad',
    phone: '235',
    language: 'Chad',
    nativeLanguage: ''
  },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
    language: 'French southern territories',
    nativeLanguage: ''
  },
  {
    code: 'TG',
    label: 'Togo',
    phone: '228',
    language: 'Togo',
    nativeLanguage: ''
  },
  {
    code: 'TH',
    label: 'Thailand',
    phone: '66',
    language: 'Thai',
    nativeLanguage: ''
  },
  {
    code: 'TJ',
    label: 'Tajikistan',
    phone: '992',
    language: 'Tajik (cyrillic)',
    nativeLanguage: ''
  },
  {
    code: 'TK',
    label: 'Tokelau',
    phone: '690',
    language: 'Tokelau',
    nativeLanguage: ''
  },
  {
    code: 'TL',
    label: 'Timor-Leste',
    phone: '670',
    language: 'Timor-leste',
    nativeLanguage: ''
  },
  {
    code: 'TM',
    label: 'Turkmenistan',
    phone: '993',
    language: 'Turkmen',
    nativeLanguage: ''
  },
  {
    code: 'TN',
    label: 'Tunisia',
    phone: '216',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'TO',
    label: 'Tonga',
    phone: '676',
    language: 'Tonga',
    nativeLanguage: ''
  },
  {
    code: 'TR',
    label: 'Turkey',
    phone: '90',
    language: 'Turkish',
    nativeLanguage: ''
  },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '1-868',
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'TV',
    label: 'Tuvalu',
    phone: '688',
    language: 'Tuvalu',
    nativeLanguage: ''
  },
  {
    code: 'TW',
    label: 'Taiwan, Province of China',
    phone: '886',
    language: 'Chinese (traditional) legacy',
    nativeLanguage: ''
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '255',
    language: 'United republic of tanzania',
    nativeLanguage: ''
  },
  {
    code: 'UA',
    label: 'Ukraine',
    phone: '380',
    language: 'Ukrainian',
    nativeLanguage: ''
  },
  {
    code: 'UG',
    label: 'Uganda',
    phone: '256',
    language: 'Uganda',
    nativeLanguage: ''
  },
  {
    code: 'US',
    label: 'United States',
    phone: '1',
    suggested: true,
    language: 'English',
    nativeLanguage: ''
  },
  {
    code: 'UY',
    label: 'Uruguay',
    phone: '598',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'UZ',
    label: 'Uzbekistan',
    phone: '998',
    language: 'Uzbek (latin)',
    nativeLanguage: ''
  },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
    language: 'Holy see (vatican city state)',
    nativeLanguage: ''
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
    language: 'Saint vincent and the grenadines',
    nativeLanguage: ''
  },
  {
    code: 'VE',
    label: 'Venezuela',
    phone: '58',
    language: 'Spanish',
    nativeLanguage: ''
  },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
    language: 'British virgin islands',
    nativeLanguage: ''
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
    language: 'Us virgin islands',
    nativeLanguage: ''
  },
  {
    code: 'VN',
    label: 'Vietnam',
    phone: '84',
    language: 'Vietnamese',
    nativeLanguage: ''
  },
  {
    code: 'VU',
    label: 'Vanuatu',
    phone: '678',
    language: 'Vanuatu',
    nativeLanguage: ''
  },
  {
    code: 'WF',
    label: 'Wallis and Futuna',
    phone: '681',
    language: 'Wallis and futuna',
    nativeLanguage: ''
  },
  {
    code: 'WS',
    label: 'Samoa',
    phone: '685',
    language: 'Samoa',
    nativeLanguage: ''
  },
  {
    code: 'XK',
    label: 'Kosovo',
    phone: '383',
    language: 'Kosovo',
    nativeLanguage: ''
  },
  {
    code: 'YE',
    label: 'Yemen',
    phone: '967',
    language: 'Arabic',
    nativeLanguage: ''
  },
  {
    code: 'YT',
    label: 'Mayotte',
    phone: '262',
    language: 'Mayotte',
    nativeLanguage: ''
  },
  {
    code: 'ZA',
    label: 'South Africa',
    phone: '27',
    language: 'Setswana',
    nativeLanguage: ''
  },
  {
    code: 'ZM',
    label: 'Zambia',
    phone: '260',
    language: 'Zambia',
    nativeLanguage: ''
  },
  {
    code: 'ZW',
    label: 'Zimbabwe',
    phone: '263',
    language: 'English',
    nativeLanguage: ''
  }
]
